/**
 * Subscribe to a media query as React state.
 *
 * The roster has two genuinely different layouts, not one layout squeezed, so
 * the page needs to know which one it is rendering rather than leaving it to
 * CSS. `usePhone` is the one breakpoint both shells agree on: below it the boss
 * shell shows its phone nav and the roster becomes lanes.
 */
import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const read = () => typeof window !== 'undefined' && window.matchMedia(query).matches;
  const [matches, setMatches] = useState(read);

  useEffect(() => {
    const mq = window.matchMedia(query);
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, [query]);

  return matches;
}

/** Tailwind's `md` breakpoint, from below: the boss shell's phone layout. */
export function usePhone(): boolean {
  return useMediaQuery('(max-width: 767px)');
}
